import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Paper,
  Button,
  Checkbox,
  TextField,
  Autocomplete,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TablePagination,
  TableBody,
  TableCell,
  styled,
  tableCellClasses,
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
} from "@mui/material";

import logoBase64 from "../../../Assets/Images/signatureworklogoreceipt.JPG";

import "jspdf-autotable";
import jsPDF from "jspdf";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { Delete, Print, Visibility } from "@mui/icons-material";
import {
  errorNotify,
  infoNotify,
  successNotify,
} from "../../../Components/ToastComponent/ToastNotification";
import TextInput from "../../../Components/InputComponents/TextInput";
import SelectInput from "../../../Components/InputComponents/SelectInput";
import TextAreaInput from "../../../Components/InputComponents/TextAreaInput";
import CommonButton from "../../../Components/InputComponents/CommonButton";
import {
  axiosAPI,
  axiosupload,
} from "../../../Components/AxiosComponents/Axios";
import { Link } from "react-router-dom";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: `#2C5F8E`,
    color: `#FFFFFF`,
    fontSize: 14,
    fontWeight: 500,
    whiteSpace: "nowrap",
    fontFamily: "Geist, sans-serif",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Geist, sans-serif",
  },
}));

function DocumentSubmission({
  candidateID,
  countryID,
  professionID,
  JAID,
  personalDetails,
  jobDetails,
}) {
  const userID =
    localStorage?.getItem("SWA_UserId") ||
    sessionStorage?.getItem("SWA_UserId");

  const [documentData, setDocumentData] = useState({ comment: "", docid: "" });

  const [reload, setReload] = useState(false);

  const [documentFile, setdocumentFile] = useState(null);
  const [docCheckList, setDocCheckList] = useState([]);
  const [docStatusList, setDocStatusList] = useState([]);

  const [errors, setErrors] = useState({});

  const [docTable, setDocTable] = useState([]);

  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);

  const [openHistory, setopenHistory] = useState(false);
  const [docHistory, setDocHistory] = useState([]);

  const [isDisabled, setIsDisabled] = useState(false);

  const [selectedDocs, setSelectedDocs] = useState([]);

  const [openPrintModal, setOpenPrintModal] = useState(false);
  const [printNote, setPrintNote] = useState("");
  const [showPassport, setShowPassport] = useState(false);
  const [showContactNumber, setShowContactNumber] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const validateForm = () => {
    const mandatoryFields = [{ field: "docid", label: "Document type" }];

    let formErrors = {};
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const phoneRegex = /^[0-9]{20}$/; // 20-digit phone validation
    for (let { field, label, type } of mandatoryFields) {
      const value = documentData[field];

      if (!value) {
        formErrors[field] = `${label} is required.`;
      } else if (type === "email" && !emailRegex.test(value)) {
        formErrors[field] = `Please enter a valid ${label}.`;
      } 
    }
    setErrors(formErrors);
    if (Object.keys(formErrors).length > 0) {
      // Display the errors as toast notifications
      Object.values(formErrors).forEach((error) => {
        errorNotify(error);
      });
      return false;
    }
    return true;
  };

  const handledocumentChange = (event) => {
    const file = event.target.files[0];
    const MAX_SIZE_MB = 30;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
    const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2); // rounded to 2 decimal places

    if (file.size > MAX_SIZE_BYTES) {
      infoNotify(
        `File size should be less than ${MAX_SIZE_MB} MB. Uploaded file size is ${fileSizeMB} MB`
      );
      return;
    }

    setdocumentFile(event.target.files[0]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors({
      ...errors,
      [name]: "",
    });

    setDocumentData({
      ...documentData,
      [name]: value,
    });
  };

  const handleStatusChange = (job, e) => {
    const now = new Date();

    const formatDateTime = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    axiosAPI
      ?.post(`/Candidate/updateCandidateDocument`, {
        DocumentId: job?.CDS_Id,
        NewStatus: e.target.value,
        ChangedAt: formatDateTime(now),
        ChangedUser:
          localStorage?.getItem("SWA_UserId") ||
          sessionStorage?.getItem("SWA_UserId"),
      })
      .then((res) => {
        if (res?.data?.success) {
          successNotify(res?.data?.data?.message);
          getDocumentTableData();
        } else {
          errorNotify(res?.data?.data?.message);
        }
      })
      .catch((err) => {});
  };

  const getDocumentTableData = async () => {
    try {
      const res = await axiosAPI.get(
        `/Candidate/getCandidateDocuments/${candidateID}/${JAID}`
      );
      setDocTable(res?.data?.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getDocumentList = async () => {
    try {
      const res = await axiosAPI.post(
        `/RecruitmentProcedureMapping/listbycountryProfession`,
        {
          countryId: countryID,
          professionId: professionID,
        }
      );
      setDocCheckList(res?.data?.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getDocStatusList = async () => {
    try {
      const res = await axiosAPI.get(`/JobApplicationStatus/docStatus`);
      setDocStatusList(res?.data?.data);
    } catch (err) {
      console.error(err);
    }
  };

  const deletefn = (id) => {
    axiosAPI
      ?.delete(`/Candidate/deleteCandidateDocumentById/${id?.CDS_Id}`)
      .then((res) => {
        if (res?.data?.success) {
          getDocumentTableData();
        } else {
          errorNotify("Couldn't Delete document.");
        }
      })
      .catch((err) => {});
  };

  const docHistoryView = async (id) => {
    try {
      const res = await axiosAPI.get(
        `/Candidate/getCandidateDocumenthistory/${id?.CDS_Id}`
      );
      setDocHistory(res?.data?.data);
    } catch (err) {
      console.error(err);
    }

    setopenHistory(true);
  };

  const handleCloseHistory = () => {
    setopenHistory(false);
  };

  const savefn = () => {
    if (validateForm()) {
      if (documentFile) {
        setIsDisabled(true);

        const now = new Date();

        const formatDateTime = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");

          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        const formData = new FormData();

        formData.append("CandidateDocument", documentFile);
        formData.append("Comment", documentData?.comment);
        formData.append("CheckListId", documentData?.docid);
        formData.append("CandidateId", candidateID);
        formData.append("CDS_JobApplicationId", JAID);
        formData.append("CDS_Date", formatDateTime(now));
        axiosupload
          ?.post(`/Candidate/addCandidateDocument`, formData)
          .then((res) => {
            if (res?.data?.success) {
              successNotify(res?.data?.data?.message);
              setReload(!reload);
              setDocumentData({ comment: "", docid: "" });
              setdocumentFile(null);
            }
            setIsDisabled(false);
          })
          .catch((err) => {
            setIsDisabled(false);
          });
      } else {
        errorNotify("Document is Required");
        setIsDisabled(false);
      }
    }
  };

  const [refcode, setRefCode] = useState("");
  const [refCodeLoading, setRefCodeLoading] = useState(false);

  const handleOpenPrintModal = async () => {
    setRefCodeLoading(true);

    const updatedSelection = selectedDocs
      .map((doc) => docTable.find((latest) => latest.CDS_Id === doc.CDS_Id))
      .filter(Boolean); // Remove undefined entries (in case a doc is missing)

    setSelectedDocs(updatedSelection);
    setOpenPrintModal(true);

    await axiosAPI
      ?.get(`/Candidate/generate-serial`)
      .then((res) => {
        if (res?.data?.success) {
          setRefCode(res?.data?.data);
          setRefCodeLoading(false);
        } else {
          setRefCode("");
          setRefCodeLoading(false);
        }
      })
      .catch((err) => {
       
        setRefCodeLoading(false);
      });
  };

  // New
  const generateReceiptPDF = (
    selectedDocs,
    note = "",
    logoBase64 = "",
    refcode = "",
  ) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginBottom = 20;
    const lineHeight = 6;

    let currentY = 20;
    const startX = 14;
    const maxWidth = pageWidth - 28;

    const checkPageSpace = (heightNeeded) => {
      if (currentY + heightNeeded > pageHeight - marginBottom) {
        doc.addPage();
        currentY = 20;
      }
    };

    // --- Header Section ---
    if (logoBase64) {
      doc.addImage(logoBase64, "PNG", 10, 10, 100, 30);
      currentY = 10;
    } else {
      currentY = 10;
    }

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(
      "Payyil Kohinoor Arcade, Samkranthi,",
      pageWidth - 84,
      currentY + 10
    );
    doc.text("Kottayam, Pin: 686016", pageWidth - 84, currentY + 14);
    doc.text("Ph. 0481 2596155, 9526416394", pageWidth - 84, currentY + 18);
    doc.text("www.signatureworkabroad.com", pageWidth - 84, currentY + 22);
    doc.text("signatureconsultancyhr@gmail.com", pageWidth - 84, currentY + 26);

    currentY += 40;

    // --- Title & Date ---
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("RECEIPT", pageWidth / 2, currentY, { align: "center" });

    currentY += 8;

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(
      `Date: ${new Date().toLocaleDateString()}`,
      pageWidth - 14,
      currentY,
      {
        align: "right",
      }
    );
    doc.text(`NO: ${refcode}`, 14, currentY);

    currentY += 6;

    // --- Passport & Contact Info ---
    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");

    if (showPassport && personalDetails?.Passport_Number) {
      checkPageSpace(lineHeight);
      doc.text(
        `Passport Number: ${personalDetails.Passport_Number}`,
        startX,
        currentY
      );
      currentY += lineHeight;
    }

    if (showContactNumber && personalDetails?.Mobile) {
      checkPageSpace(lineHeight);
      doc.text(`Contact Number: ${personalDetails.Mobile}`, startX, currentY);
      currentY += lineHeight;
    }

    currentY += 4;

    // --- Acknowledgement Line ---
    const name = personalDetails.Name || "N/A";
    const introText = "Received originals of the following documents from ";
    const endingText = " for further processing:";

    checkPageSpace(lineHeight);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(introText, startX, currentY);

    const introWidth = doc.getTextWidth(introText);
    doc.setFont("helvetica", "bold");
    doc.text(name, startX + introWidth, currentY);

    const nameWidth = doc.getTextWidth(name);
    doc.setFont("helvetica", "normal");
    doc.text(endingText, startX + introWidth + nameWidth, currentY);

    currentY += 8;

    // --- Document List (Paginated) ---
    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");

    // For testing, repeat 4x. Use `selectedDocs` directly in real use.
    // const repeatedDocs = Array(3).fill(selectedDocs).flat();

    // repeatedDocs.forEach((item, index) => {
    //   const line = `${index + 1}) ${item.CDS_CheckListName}`;
    //   if (currentY + lineHeight > pageHeight - marginBottom) {
    //     doc.addPage();
    //     currentY = 20;
    //   }
    //   doc.text(line, startX, currentY);
    //   currentY += lineHeight;
    // });

    //   // --- Document List ---
    const documentList = selectedDocs
      .map((item, index) => `${index + 1}) ${item.CDS_CheckListName}`)
      .join("\n");

    const docLines = doc.splitTextToSize(documentList, maxWidth);
    const docHeight = docLines.length * lineHeight;

    checkPageSpace(docHeight);
    doc.text(docLines, startX, currentY);
    currentY += docHeight - 6;

    // --- Note Section ---
    if (note?.trim()) {
      const noteLines = doc.splitTextToSize(note, maxWidth);
      const noteHeight = noteLines.length * 5;

      checkPageSpace(noteHeight + 16);
      doc.setFontSize(11);
      doc.text("Note:", startX, currentY + 10);

      doc.setFontSize(10);
      doc.text(noteLines, startX, currentY + 16);

      currentY = currentY + 16 + noteHeight + 4;
    }

    // --- Footer Section ---
    let footerY = currentY + 8;
    checkPageSpace(30);

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("Received Originals", startX, footerY);
    footerY += 8;

    doc.text("Authorized Signature: __________________", startX, footerY);
    doc.text("Candidate Signature: __________________", pageWidth / 2, footerY);

    // --- Log Print Action ---
    axiosAPI
      ?.post(`/Candidate/print-log`, {
        candidateId: candidateID,
        userId: userID,
        serialNumber: refcode,
      })
      .then((res) => {
        if (res?.data?.success) {
          if (refcode) {
            doc.save("Document_Receipt.pdf");
            setOpenPrintModal(false);
            setPrintNote("");
          } else {
            infoNotify("Reference Number is Missing.");
          }
        } else {
          errorNotify("Something went wrong!");
        }
      })
      .catch((err) => {
        
      });
  };

  const isSelected = (id) => selectedDocs.some((doc) => doc.CDS_Id === id);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = docTable.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );
      setSelectedDocs((prev) => {
        const unique = [...prev];
        newSelecteds.forEach((doc) => {
          if (!unique.some((d) => d.CDS_Id === doc.CDS_Id)) {
            unique.push(doc);
          }
        });
        return unique;
      });
    } else {
      const start = page * rowsPerPage;
      const end = start + rowsPerPage;
      const idsToRemove = docTable.slice(start, end).map((doc) => doc.CDS_Id);
      setSelectedDocs((prev) =>
        prev.filter((doc) => !idsToRemove.includes(doc.CDS_Id))
      );
    }
  };

  const handleCheckboxClick = (event, log) => {
    const isChecked = event.target.checked;
    setSelectedDocs((prev) => {
      if (isChecked) {
        return [...prev, log];
      } else {
        return prev.filter((doc) => doc.CDS_Id !== log.CDS_Id);
      }
    });
  };

  useEffect(() => {
    getDocumentTableData();
    if (countryID && professionID) {
      getDocumentList();
    }
  }, [countryID, reload]);

  useEffect(() => {
    getDocStatusList();
  }, []);

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 1,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
        my={2}
      >
        Document Submission
      </Typography>
      <Grid
        container
        sx={{
          backgroundColor: "#fff", // Optional: card background
        }}
        spacing={2}
      >
        {/* Document type */}
        <Grid item xs={12} md={6} lg={3} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Document type <span style={{ color: "red" }}> * </span>
          </Typography>

          <SelectInput
            value={documentData.docid}
            name="docid"
            onChange={handleInputChange}
            options={
              docCheckList?.Documents
                ? docCheckList?.Documents?.map((p) => ({
                    label: p?.DocumentName,
                    value: p?.DocumentID,
                  }))
                : []
            }
            placeholder="Select Document"
            error={!!errors.docid}
          />
        </Grid>

        {/* Comment */}
        <Grid item xs={12} md={6} lg={3} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Comment
          </Typography>
          <TextInput
            label="Comment"
            placeholder="Enter your Comment"
            name="comment"
            value={documentData.comment}
            onChange={handleInputChange}
          />
        </Grid>

        {/* Document Upload */}
        <Grid item xs={12} md={12} lg={6} xl={6}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Document Upload <span style={{ color: "red" }}> * </span>
          </Typography>

          {/* Hidden file input */}
          <input
            style={{ display: "none" }}
            id="picture-upload"
            type="file"
            onChange={handledocumentChange}
          />

          {/* Flex row: Upload Button + Preview */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              mt: "2px",
              gap: 2,
            }}
          >
            {/* Upload button */}
            <label htmlFor="picture-upload">
              <Button
                variant="contained"
                component="span"
                startIcon={<CloudUploadIcon />}
                sx={{
                  backgroundColor: "#3498DB",
                  color: "#fff",
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                {documentFile ? "Change File" : "Choose File"}
              </Button>
            </label>

            {/* Preview & Delete */}
            {documentFile && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <InsertDriveFileIcon color="action" />
                <Typography
                  component="a"
                  href={URL.createObjectURL(documentFile)}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "#007BFF",
                    textDecoration: "underline",
                    cursor: "pointer",
                    fontSize: "14px",
                    maxWidth: "200px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={documentFile.name}
                >
                  {documentFile.name}
                </Typography>

                <IconButton
                  onClick={() => setdocumentFile(null)}
                  aria-label="delete"
                  size="small"
                  sx={{ color: "red" }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
          </Box>
        </Grid>

        {/* Save Button */}
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            height: "100%", // Ensure the container fills available vertical space
          }}
        >
          <Button
            variant="contained"
            customColor="#007BFF"
            onClick={savefn}
            disabled={isDisabled}
          >
            {isDisabled ? "Saving..." : "Save"}
          </Button>
        </Grid>
      </Grid>
      <Box
        sx={{
          borderRadius: "10px",
          overflowX: "auto",
          width: "100%",
          maxWidth: "100vw",
          margin: "auto",
        }}
      >
        {/* Table */}
        <TableContainer
          sx={{
            border: "1px solid transparent",
            borderRadius: "10px",
            maxWidth: "100%",
            overflowX: "auto",
            margin: "10px auto",
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                {docTable?.length > 0 && (
                  <StyledTableCell padding="checkbox">
                    <Checkbox
                      indeterminate={
                        selectedDocs.length > 0 &&
                        selectedDocs.length <
                          docTable.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          ).length
                      }
                      checked={
                        docTable?.length > 0 &&
                        selectedDocs.filter((doc) =>
                          docTable
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .some((d) => d.CDS_Id === doc.CDS_Id)
                        ).length ===
                          docTable.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          ).length
                      }
                      onChange={handleSelectAllClick}
                      sx={{
                        color: "white",
                        "&.Mui-checked": {
                          color: "white",
                        },
                        "&.MuiCheckbox-indeterminate": {
                          color: "white", // color for indeterminate state
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: 28, // size for checkbox icon (including indeterminate)
                        },
                      }}
                    />
                  </StyledTableCell>
                )}

                <StyledTableCell sx={{ width:"50px" }}>#</StyledTableCell>
                <StyledTableCell>Document Name</StyledTableCell>
                <StyledTableCell sx={{ minWidth: "300px" }}>
                  Comment
                </StyledTableCell>
                <StyledTableCell sx={{ minWidth: "300px" }}>
                  File
                </StyledTableCell>
                <StyledTableCell sx={{ minWidth: "300px" }}>
                  Document Status
                </StyledTableCell>
                <StyledTableCell sx={{ textAlign: "center" }}>
                  Action
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {docTable && docTable.length > 0 ? (
                docTable
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((log, index) => (
                    <TableRow key={log.CDS_Id} hover>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isSelected(log.CDS_Id)}
                          onChange={(e) => handleCheckboxClick(e, log)}
                        />
                      </TableCell>
                      <TableCell>{index + 1 + page * rowsPerPage}</TableCell>
                      <TableCell>{log?.CDS_CheckListName}</TableCell>
                      <TableCell>{log?.CDS_Comment || "-"}</TableCell>
                      <TableCell>
                        <Link
                          target="_blank"
                          to={`${process.env.REACT_APP_BASE_URL}/${log?.CDS_DocumentPath}`}
                        >
                          {log?.CDS_DocumentName}
                        </Link>
                      </TableCell>
                      <TableCell>
                        <SelectInput
                          value={log?.CDS_Status}
                          onChange={(e) => handleStatusChange(log, e)}
                          options={docStatusList?.map((item) => ({
                            value: item?.DSS_Id,
                            label: item?.DSS_Name,
                          }))}
                          placeholder="Select Document Status"
                        />
                      </TableCell>
                      <TableCell align="center">
                        <IconButton
                          color="info"
                          onClick={() => docHistoryView(log)}
                        >
                          <Visibility />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => {
                            setSelectedDoc(log);
                            setOpenConfirm(true);
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    <Typography
                      variant="body2"
                      sx={{
                        py: 2,
                        fontSize: "20px",
                        fontFamily: "Geist, sans-serif",
                      }}
                    >
                      No data available
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {selectedDocs?.length > 0 && (
        <Box
          sx={{
            borderRadius: "10px",
            overflowX: "auto",
            width: "100%",
            maxWidth: "100vw",
            margin: "auto",
            display: "flex",
            justifyContent: "flex-end", // Aligns content to the right
            padding: 1,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            startIcon={<Print />}
            onClick={handleOpenPrintModal}
            disabled={refCodeLoading}
          >
            {refCodeLoading ? "Loading" : "Print Receipt"}
          </Button>
        </Box>
      )}

      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            color: "#0977BC",
            mt: 3,
            mb: 2,
            fontFamily: "Geist, sans-serif",
          }}
        >
          Confirm Deletion
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
              mb: 1,
              fontFamily: "Geist, sans-serif",
            }}
          >
            Are you sure you want to delete this document? This action cannot be
            undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ mt: 3, mb: 3, mr: 3 }}>
          <CommonButton
            variant="outlined"
            customColor="#B0BEC5"
            onClick={() => setOpenConfirm(false)}
          >
            Cancel
          </CommonButton>
          <CommonButton
            variant="contained"
            customColor="#007BFF"
            onClick={() => {
              deletefn(selectedDoc);
              setOpenConfirm(false);
            }}
          >
            Delete
          </CommonButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPrintModal && refcode && !refCodeLoading}
        onClose={() => {
          setOpenPrintModal(false);
          setPrintNote("");
          setRefCode("");
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ pb: 0 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
          >
            {/* Logo on the left */}
            <Box>
              <img
                src={logoBase64}
                alt="Company Logo"
                style={{ maxHeight: 100 }}
              />
            </Box>

            {/* Company Address on the right */}
            <Box textAlign="left">
              <Typography variant="body2">
                Payyil Kohinoor Arcade, Sankranthi,
              </Typography>
              <Typography variant="body2">Kottayam, Pin: 686016</Typography>
              <Typography variant="body2">
                Ph: 0481 2596155, 9526416394
              </Typography>
              <Typography variant="body2">
                www.signatureworkabroad.com
              </Typography>
              <Typography variant="body2">
                signatureconsultancyhr@gmail.com
              </Typography>
            </Box>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ pt: 2 }}>
          {/* Centered Title */}
          <Typography
            variant="h5"
            fontWeight="bold"
            align="center"
            sx={{ mb: 3 }}
          >
            RECEIPT
          </Typography>

          {/* Title Row */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" fontWeight="bold">
              NO: {refcode}
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              Date: {new Date().toLocaleDateString()}
            </Typography>
          </Box>

          {/* Acknowledgement Text */}
          <Typography variant="body1" sx={{ mb: 2, whiteSpace: "pre-line" }}>
            Received originals of the following documents from{" "}
            <strong>{personalDetails.Name || "N/A"}</strong> for further
            processing:
          </Typography>

          {/* Document List Table */}
          <Table size="small" sx={{ mb: 2 }}>
            <TableHead>
              <TableRow>
                <StyledTableCell sx={{ width:"50px" }}>#</StyledTableCell>
                <StyledTableCell>Document Name</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedDocs.map((doc, index) => (
                <TableRow key={doc.CDS_Id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{doc.CDS_CheckListName}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

                {/* Checkboxes */}
          <Box sx={{ mt: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showPassport}
                  onChange={(e) => setShowPassport(e.target.checked)}
                />
              }
              label="Show Passport number"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={showContactNumber}
                  onChange={(e) => setShowContactNumber(e.target.checked)}
                />
              }
              label="Show Contact Number"
            />
          </Box>

          {/* Note Section */}
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Note (for acknowledgement)"
            value={printNote}
            onChange={(e) => setPrintNote(e.target.value)}
            inputProps={{ maxLength: 250 }}
            helperText={`${printNote.length}/250 characters`}
            sx={{ mt: 3 }}
          />

    

          {/* Signature Section */}
          {/* <Box
            mt={4}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography variant="subtitle2">Received Originals</Typography>
              <Typography variant="subtitle2" sx={{ mt: 2 }}>
                Authorized Signature: ______________________
              </Typography>
            </Box>

            <Box>
              <Typography variant="subtitle2" sx={{ mt: 6 }}>
                Candidate Signature: ______________________
              </Typography>
            </Box>
          </Box> */}
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            variant="outlined"
            onClick={() => {
              setOpenPrintModal(false);
              setRefCode("");
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              generateReceiptPDF(
                selectedDocs,
                printNote,
                logoBase64,
                refcode
              );
            }}
            variant="contained"
            color="primary"
            sx={{ ml: 2 }}
          >
            Print
          </Button>
        </DialogActions>
      </Dialog>


      {/* <TablePagination
        component="div"
        count={docTable.length}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[25, 50, 75, 100]}
        sx={{
          fontSize: { xs: "12px", sm: "14px" },
          "& .MuiTablePagination-selectLabel": {
            fontSize: { xs: "12px", sm: "14px" },
            fontFamily: "Geist, sans-serif",
          },
        }}
      /> */}

      <Dialog
        open={openHistory}
        onClose={handleCloseHistory}
        maxWidth="md"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>Document Status Change History</DialogTitle>

        <DialogContent dividers>
          {docHistory?.length > 0 ? (
            <Box sx={{ overflowX: "auto" }}>
              <Table size="small">
                <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                  <TableRow>
                    <StyledTableCell>#</StyledTableCell>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>Changed By</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {docHistory.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{item?.CDH_Date}</TableCell>
                      <TableCell>{item?.ED_Name || "-"}</TableCell>
                      <TableCell>{item?.DSS_Name}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          ) : (
            <Typography variant="body2" sx={{ mt: 1 }}>
              No history available.
            </Typography>
          )}
        </DialogContent>

        <DialogActions
          sx={{ display: "flex", justifyContent: "flex-end", m: 2 }}
        >
          <Button onClick={handleCloseHistory} variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
}

export default DocumentSubmission;
